import { createContext, useContext } from 'react';
import { LOGOUT, SET_2FA_DATA, SET_ACCOUNT, SET_ACCOUNT_GROUPS, SET_ACCOUNTS, SET_AUTHDATA, SET_CURRENT_CUSTOMER, SET_MESSAGES, SET_PASSWORD_LOGIN_DATA, SET_PAYMENT_METHODS, SET_USER } from 'store/actions/actions';
const initState = () => {
    const token = localStorage.getItem('accessToken');
    const initialData = {
        accessToken: '',
        account: null,
        accountGroups: null,
        accountSettings: {},
        invoices: null,
        messages: [],
        modalType: '',
        otpImage: '',
        otpToken: '',
        signinEmail: '',
        signinSsoBackup: false,
        paymentMethods: [],
        user: null,
        resToken: '',
        source: ''
    };
    return {
        ...initialData,
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        accessToken: token || ''
    };
};
export const initialState = initState();
export function rootReducer(state, action) {
    state ??= initialState;
    switch (action.type) {
        case SET_AUTHDATA:
            return {
                ...state,
                // TODO: We re-use `AuthData` interface for API responses and internal stuff, we need to split these
                accessToken: action.payload.accessToken,
                account: action.payload.account,
                resToken: action.payload.resToken,
                user: action.payload.user
            };
        case LOGOUT:
            return {
                ...state,
                accessToken: '',
                account: action.payload.account,
                signinSsoBackup: false,
                user: action.payload.user
            };
        case SET_USER:
            return {
                ...state,
                user: action.payload.user
            };
        case SET_ACCOUNT_GROUPS:
            return {
                ...state,
                accountGroups: action.payload.accountGroups
            };
        case SET_ACCOUNTS:
            return {
                ...state,
                accounts: action.payload.accounts
            };
        case SET_ACCOUNT:
            return {
                ...state,
                account: action.payload.account
            };
        case SET_MESSAGES:
            return {
                ...state,
                messages: action.payload
            };
        case SET_2FA_DATA:
            return {
                ...state,
                otpImage: action.payload.otpImage,
                otpToken: action.payload.otpToken,
                resToken: action.payload.resToken
            };
        case SET_PASSWORD_LOGIN_DATA:
            return {
                ...state,
                signinEmail: action.payload.email,
                signinSsoBackup: action.payload.ssoBackup ?? false
            };
        case SET_CURRENT_CUSTOMER:
            return {
                ...state,
                customer: action.payload.currentCustomer
            };
        case SET_PAYMENT_METHODS:
            return {
                ...state,
                paymentMethods: action.payload.paymentMethods
            };
    }
}
const StoreContext = createContext({});
export const StoreProvider = StoreContext.Provider;
export const useGlobalState = () => useContext(StoreContext);
